import type { Post } from "@/types/content";

export const postsPart1: Post[] = [
  {
    id: "post-1",
    slug: "taipei-massage-top10",
    title: "台北按摩推薦 TOP 10｜神秘客實測最專業的舒壓體驗",
    excerpt: "我們派出了 5 位神秘客，實際走訪台北 30 間按摩店家，從環境、手技、CP 值三個維度評比，精選出這 10 間最值得推薦的按摩好去處。",
    coverImage: "https://readdy.ai/api/search-image?query=Relaxing%20professional%20massage%20therapy%20room%20with%20warm%20candlelight%20soft%20towels%20and%20essential%20oils%20on%20wooden%20table%20zen%20interior%20photography%20clean%20neutral%20background&width=1200&height=630&seq=101&orientation=landscape",
    category: "按摩",
    contentType: "multiShopReview",
    tags: ["台北", "按摩", "舒壓", "SPA", "中山區", "大安區", "懶人包", "推薦"],
    author: {
      id: "author-1",
      name: "Amy編",
      avatar: "https://readdy.ai/api/search-image?query=Young%20asian%20woman%20portrait%20friendly%20smile%20clean%20white%20background%20lifestyle%20headshot&width=100&height=100&seq=201&orientation=squarish",
      bio: "資深美業神秘客，專精按摩與做臉/皮膚管理類評測。累積實地走訪超過 60 間按摩會館、SPA 與美容工作室，對於師傅手法、產品成分與療程效果有敏銳的判斷力。堅持匿名探訪，每次評比都親自體驗完整流程，確保資訊真實可靠。",
    },
    publishedAt: "2025-04-15",
    readingTime: 12,
    rating: 4.6,
    reviewCount: 128,
    content: [
      {
        _type: "richText",
        _key: "intro",
        content: "<p>在繁忙的台北都市生活中，找一間好的按摩店放鬆身心，是許多人的週末儀式。但市面上按摩店家這麼多，要怎麼選才不踩雷？</p><p>這次美好時光指南派出了 5 位神秘客，匿名實際走訪台北 30 間按摩店家，從<strong>環境舒適度、手技專業度、整體 CP 值</strong>三個維度評比，精選出這 10 間最值得推薦的按摩好去處。</p><p>以下評比完全匿名進行，店家並不知曉我們的身分，確保評價真實客觀。</p>",
      },
      {
        _type: "featureList",
        _key: "criteria",
        title: "評比標準說明",
        features: [
          { _key: "c1", icon: "ri-hotel-bed-line", title: "環境舒適度 (30%)", description: "空間整潔、隱私性、音樂與香氛氛圍、等候區舒適度" },
          { _key: "c2", icon: "ri-hand-heart-line", title: "手技專業度 (40%)", description: "師傅證照、手法細膩度、穴位準確性、力道溝通與調整" },
          { _key: "c3", icon: "ri-coins-line", title: "整體 CP 值 (30%)", description: "價格合理性、服務完整性、回訪意願" },
        ],
      },
      {
        _type: "shopReview",
        _key: "reviews",
        title: "TOP 10 按摩店家評比",
        shops: [
          {
            _key: "s1",
            name: "舒壓秘境 SPA",
            rating: 4.9,
            priceRange: "$1,200 - $3,500",
            address: "台北市大安區忠孝東路四段 123 號 2F",
            tags: ["獨立包廂", "淋浴設施", "情侶雙人房"],
            pros: ["師傅手法細膩，穴位按得很準", "包廂隱私性極佳，完全不受打擾", "療程後的手工餅乾超好吃"],
            cons: ["週末較難預約，建議提前一週", "價格偏高，適合犒賞自己"],
            recommendation: "適合追求高品質舒壓體驗的人，情侶一起來也很棒。建議選 90 分鐘深層油壓療程。",
            image: "https://readdy.ai/api/search-image?query=Luxury%20spa%20treatment%20room%20with%20warm%20amber%20lighting%20candles%20and%20flower%20petals%20on%20massage%20table%20zen%20minimalist%20interior%20simple%20clean%20background&width=600&height=400&seq=301&orientation=landscape",
            storeUrl: "https://www.google.com/maps/search/?api=1&query=舒壓秘境+SPA+台北",
          },
          {
            _key: "s2",
            name: "足享養生會館",
            rating: 4.7,
            priceRange: "$800 - $2,000",
            address: "台北市中山區南京東路二段 88 號 B1",
            tags: ["腳底按摩", "修復按摩", "24hr"],
            pros: ["24 小時營業，加班族福音", "腳底按摩師傅經驗豐富，會找到你的痛點", "價格親民，CP 值很高"],
            cons: ["環境較老舊，隔音普通", "需共用更衣區"],
            recommendation: "深夜想放鬆的首選，腳底按摩 60 分鐘只要 $800，小腿浮腫按完馬上消。",
            image: "https://readdy.ai/api/search-image?query=Traditional%20foot%20massage%20spa%20interior%20with%20bamboo%20decoration%20warm%20lighting%20clean%20simple%20background%20photography&width=600&height=400&seq=302&orientation=landscape",
            storeUrl: "https://www.google.com/maps/search/?api=1&query=足享養生會館+台北",
          },
          {
            _key: "s3",
            name: "靜心推拿館",
            rating: 4.6,
            priceRange: "$1,000 - $2,800",
            address: "台北市信義區松壽路 18 號 3F",
            tags: ["整復推拿", "運動按摩", "證照師傅"],
            pros: ["師傅都有國家證照，專業度滿分", "運動按摩後痠痛明顯改善", "會主動詢問身體狀況並調整手法"],
            cons: ["預約制，臨時較難安排", "療程較偏功能性，放鬆感稍弱"],
            recommendation: "長期肩頸僵硬或運動後恢復的人必推。整復推拿 90 分鐘會讓你感覺換了一副肩膀。",
            image: "https://readdy.ai/api/search-image?query=Professional%20massage%20therapist%20working%20on%20client%20back%20in%20clean%20modern%20clinic%20room%20simple%20neutral%20background%20photography&width=600&height=400&seq=303&orientation=landscape",
            storeUrl: "https://www.google.com/maps/search/?api=1&query=靜心推拿館+台北",
          },
          {
            _key: "s4",
            name: "東方經絡養生館",
            rating: 4.5,
            priceRange: "$600 - $1,800",
            address: "台北市萬華區西寧南路 45 號 4F",
            tags: ["經絡按摩", "刮痧", "拔罐"],
            pros: ["傳統中式技法正宗，經絡按得很到位", "刮痧拔罐一條龍，價格超划算", "老師傅經驗超過 20 年"],
            cons: ["環境較傳統，不是網美風", "沒有獨立包廂"],
            recommendation: "喜歡傳統中式按摩的人必來。經絡調理 + 刮痧 $1,200，濕氣重的人按完超舒爽。",
            image: "https://readdy.ai/api/search-image?query=Traditional%20chinese%20medicine%20massage%20room%20with%20red%20wood%20decor%20warm%20ambient%20lighting%20simple%20background%20photography&width=600&height=400&seq=304&orientation=landscape",
            storeUrl: "https://www.google.com/maps/search/?api=1&query=東方經絡養生館+台北",
          },
          {
            _key: "s5",
            name: "森呼吸芳療所",
            rating: 4.5,
            priceRange: "$1,500 - $4,000",
            address: "台北市士林區中山北路五段 220 號",
            tags: ["精油芳療", "熱石按摩", "孕婦按摩"],
            pros: ["精油品質很好，味道天然不刺鼻", "孕婦按摩是台北少數專業的", "環境超美，像走進森林小屋"],
            cons: ["地點較偏遠，捷運需轉公車", "高單價療程較多"],
            recommendation: "孕婦或對精油品質有要求的人首選。熱石按摩冬天做超舒服，石頭溫度維持很久。",
            image: "https://readdy.ai/api/search-image?query=Aromatherapy%20spa%20room%20with%20essential%20oil%20diffuser%20green%20plants%20and%20natural%20wood%20decoration%20warm%20cozy%20lighting%20simple%20background&width=600&height=400&seq=305&orientation=landscape",
            storeUrl: "https://www.google.com/maps/search/?api=1&query=森呼吸芳療所+台北",
          },
        ],
      },
      {
        _type: "richText",
        _key: "summary",
        content: "<h3>總結與建議</h3><p>這次評比下來，我們發現台北按摩市場兩極化蠻明顯的——高單價精品店與平價連鎖店各有擁護者。</p><p>如果你追求<strong>極致放鬆與隱私</strong>，舒壓秘境 SPA 和森呼吸芳療所是首選；如果你在意<strong>CP 值與方便性</strong>，足享養生會館和東方經絡養生館絕對不會讓你失望。</p>",
      },
      {
        _type: "faq",
        _key: "faq",
        title: "常見問題",
        items: [
          { _key: "q1", question: "第一次按摩要選什麼療程？", answer: "建議從 60 分鐘的全身指壓或精油按摩開始，讓身體適應師傅的力道。如果肩頸特別僵硬，可以直接選針對局部的療程。" },
          { _key: "q2", question: "按摩前需要注意什麼？", answer: "避免空腹或剛吃飽馬上按摩；告知師傅你的身體狀況與受傷史；有皮膚過敏記得要說，避免使用精油。" },
          { _key: "q3", question: "多久按摩一次比較好？", answer: "一般保養建議 2-4 週一次；如果是運動恢復或長期痠痛，可每週一次。按摩後多喝水，幫助代謝乳酸。" },
        ],
      },
      {
        _type: "cta",
        _key: "cta",
        title: "加入美好時光指南神秘客團隊",
        subtitle: "實際體驗店家，撰寫公正評比，幫助更多人找到不踩雷的按摩好去處",
        buttonLabel: "了解神秘客計畫",
        buttonHref: "/join-us",
      },
    ],
    seo: {
      title: "台北按摩推薦 TOP 10｜神秘客實測評比 2025",
      description: "神秘客實際走訪台北 30 間按摩店家，精選 TOP 10 舒壓好去處。環境、手技、CP 值完整評比，附優缺點與 Google Maps 連結。",
      keywords: ["台北按摩", "按摩推薦", "SPA", "舒壓", "神秘客評比"],
    },
  },
  {
    id: "post-2",
    slug: "taipei-spa-top8",
    title: "台北 SPA 推薦 TOP 8｜從千元到萬元等級全面評比",
    excerpt: "SPA 品質參差不齊，踩雷機率高。這篇由神秘客實測台北 20 間 SPA 會館，從平價到奢華一網打盡，帶你找到最符合預算的質感體驗。",
    coverImage: "https://readdy.ai/api/search-image?query=Elegant%20spa%20interior%20with%20candles%20flowers%20and%20private%20treatment%20room%20warm%20golden%20lighting%20luxury%20wellness%20center%20photography%20clean%20simple%20background&width=1200&height=630&seq=102&orientation=landscape",
    category: "SPA",
    contentType: "multiShopReview",
    tags: ["台北", "SPA", "按摩", "舒壓", "評比", "懶人包", "推薦"],
    author: {
      id: "author-1",
      name: "Amy編",
      avatar: "https://readdy.ai/api/search-image?query=Young%20asian%20woman%20portrait%20friendly%20smile%20clean%20white%20background%20lifestyle%20headshot&width=100&height=100&seq=201&orientation=squarish",
      bio: "資深美業神秘客，專精按摩與做臉/皮膚管理類評測。累積實地走訪超過 60 間按摩會館、SPA 與美容工作室，對於師傅手法、產品成分與療程效果有敏銳的判斷力。堅持匿名探訪，每次評比都親自體驗完整流程，確保資訊真實可靠。",
    },
    publishedAt: "2025-04-10",
    readingTime: 10,
    rating: 4.5,
    reviewCount: 96,
    content: [
      {
        _type: "richText",
        _key: "intro",
        content: "<p>台北的 SPA 市場從 $800 的平價油壓到 $8,000 起的精品 resort SPA 都有，但品質良莠不齊。神秘客這次分成三個預算帶實測，幫你找到每個價位中最值得去的選擇。</p>",
      },
      {
        _type: "featureList",
        _key: "categories",
        title: "三大預算帶推薦",
        features: [
          { _key: "f1", icon: "ri-coins-line", title: "平價帶（$800-$2,000）", description: "CP 值高，適合頻繁保養的上班族。推薦：足享養生、東方經絡" },
          { _key: "f2", icon: "ri-vip-crown-line", title: "中價帶（$2,000-$5,000）", description: "品質穩定，包廂獨立，適合偶爾犒賞。推薦：舒壓秘境、靜心推拿" },
          { _key: "f3", icon: "ri-sparkling-line", title: "高價帶（$5,000+）", description: "頂級設施與服務，適合特殊節日或招待貴賓。推薦：森呼吸芳療、五星飯店 SPA" },
        ],
      },
      {
        _type: "cta",
        _key: "cta",
        title: "看更多 SPA 評比",
        subtitle: "神秘客實測台北 SPA 會館，公正評比幫你找到最值得的體驗",
        buttonLabel: "查看完整評比",
        buttonHref: "#",
      },
    ],
    seo: {
      title: "台北 SPA 推薦 TOP 8｜神秘客實測各預算帶評比",
      description: "台北 SPA 評比！從平價到奢華，神秘客實測 20 間，找到最符合預算的質感體驗。附優缺點分析。",
      keywords: ["台北SPA", "SPA推薦", "按摩推薦", "舒壓", "評比"],
    },
  },
  {
    id: "post-3",
    slug: "taipei-vietnamese-shampoo-top6",
    title: "台北越式洗髮推薦 TOP 6｜放鬆感爆表的頭皮護理體驗",
    excerpt: "越式洗髮憑藉獨特的按摩手法迅速席捲台灣，但品質差距極大。這篇神秘客實測台北 15 間越式洗髮，挑出手法最扎實、最物超所值的 6 間。",
    coverImage: "https://readdy.ai/api/search-image?query=Vietnamese%20hair%20wash%20salon%20with%20reclining%20chairs%20warm%20lighting%20professional%20scalp%20massage%20service%20clean%20interior%20photography%20simple%20background&width=1200&height=630&seq=103&orientation=landscape",
    category: "越式洗髮",
    contentType: "multiShopReview",
    tags: ["台北", "越式洗髮", "頭皮按摩", "洗頭", "舒壓", "懶人包", "推薦"],
    author: {
      id: "author-2",
      name: "Chen 神秘客",
      avatar: "https://readdy.ai/api/search-image?query=Young%20asian%20man%20portrait%20confident%20smile%20clean%20white%20background%20professional%20headshot&width=100&height=100&seq=202&orientation=squarish",
      bio: "資深美業神秘客，專精美髮造型與頭皮護理類評測。走訪台灣超過 80 間美髮沙龍、頭皮護理中心與越式洗髮店，對於設計師技術、護理產品成分與頭皮檢測儀器有深入研究。堅持匿名探訪，給讀者最直白的消費建議。",
    },
    publishedAt: "2025-04-05",
    readingTime: 8,
    rating: 4.7,
    reviewCount: 142,
    content: [
      {
        _type: "richText",
        _key: "intro",
        content: "<p>越式洗髮的魅力在於那套獨特的「捏、壓、揉、敲」按摩手法，從頭皮延伸到肩頸，60-90 分鐘結束後整個人像重生一樣。但台灣越式洗髮店良莠不齊——有些真的是越南師傅正宗手法，有些根本只是普通洗頭加收越式價格。</p><p>這次我們神秘客走訪台北 15 間越式洗髮店，從手法扎實度、頭皮清潔效果、按摩覆蓋範圍三個維度評比，精選出 6 間最值得去的。</p>",
      },
      {
        _type: "shopReview",
        _key: "reviews",
        title: "TOP 6 越式洗髮評比",
        shops: [
          {
            _key: "s1",
            name: "河內髮廊",
            rating: 4.9,
            priceRange: "$500 - $900",
            address: "台北市中山區林森北路 98 號 2F",
            tags: ["越南師傅", "正宗手法", "頭皮護理"],
            pros: ["師傅是越南當地訓練，手法正宗", "按摩範圍從頭皮到背部全覆蓋", "價格親民，CP 值全台北最高"],
            cons: ["環境裝潢較老舊", "店內偶有人聲嘈雜"],
            recommendation: "想體驗最正宗越式洗髮的首選。建議選 90 分鐘套餐，多了背部按摩，值回票價。",
            image: "https://readdy.ai/api/search-image?query=Vietnamese%20style%20hair%20wash%20salon%20with%20comfortable%20reclining%20chairs%20soft%20warm%20lighting%20professional%20service%20simple%20clean%20background%20photography&width=600&height=400&seq=311&orientation=landscape",
            storeUrl: "https://www.google.com/maps/search/?api=1&query=河內髮廊+台北+中山區",
          },
          {
            _key: "s2",
            name: "西貢洗髮坊",
            rating: 4.7,
            priceRange: "$600 - $1,100",
            address: "台北市大安區敦化南路一段 200 號 B1",
            tags: ["精品環境", "精油洗髮", "頭皮診斷"],
            pros: ["環境乾淨明亮，包廂空間大", "師傅上工前會先問頭皮狀況", "精油選項豐富，可依髮質客製"],
            cons: ["價格略高於平均", "旺季等候約 20 分鐘"],
            recommendation: "想在精緻環境享受越式手法的首選。頭皮診斷後的客製化療程讓人感覺真的被重視。",
            image: "https://readdy.ai/api/search-image?query=Modern%20premium%20hair%20salon%20with%20private%20wash%20stations%20essential%20oils%20and%20professional%20equipment%20warm%20ambient%20lighting%20simple%20background%20photography&width=600&height=400&seq=312&orientation=landscape",
            storeUrl: "https://www.google.com/maps/search/?api=1&query=西貢洗髮坊+台北+大安區",
          },
        ],
      },
      {
        _type: "faq",
        _key: "faq",
        title: "越式洗髮常見問題",
        items: [
          { _key: "q1", question: "越式洗髮和一般洗頭有什麼不同？", answer: "越式洗髮強調按摩手法，通常包含頭皮、頸部、肩部甚至背部的按摩，時間較長（60-90分鐘），放鬆效果比一般洗頭好很多。" },
          { _key: "q2", question: "多久做一次越式洗髮比較好？", answer: "一般建議 2-4 週一次作為日常保養，頭皮敏感或出油問題嚴重者可縮短至每週一次。" },
        ],
      },
      {
        _type: "cta",
        _key: "cta",
        title: "看更多越式洗髮評比",
        subtitle: "神秘客實測台北越式洗髮店，公正評比手法與服務品質",
        buttonLabel: "查看評比",
        buttonHref: "#",
      },
    ],
    seo: {
      title: "台北越式洗髮推薦 TOP 6｜神秘客實測正宗手法評比",
      description: "台北越式洗髮評比！神秘客實測 15 間，精選 6 間最扎實的頭皮護理體驗。附優缺點與 Google Maps 連結。",
      keywords: ["台北越式洗髮", "越式洗髮推薦", "頭皮按摩", "洗頭推薦"],
    },
  },
  {
    id: "post-4",
    slug: "taipei-ear-cleaning-top5",
    title: "台北采耳推薦 TOP 5｜酥到靈魂出竅的極致清潔體驗",
    excerpt: "采耳不只是清耳朵，更是一種深度放鬆的感官體驗。神秘客走訪台北 12 間采耳店，精選出手法最細膩、環境最舒適的 5 間。",
    coverImage: "https://readdy.ai/api/search-image?query=Relaxing%20ear%20cleaning%20salon%20with%20soft%20lighting%20comfortable%20recliner%20chair%20professional%20ear%20care%20service%20clean%20modern%20interior%20simple%20background%20photography&width=1200&height=630&seq=104&orientation=landscape",
    category: "采耳",
    contentType: "multiShopReview",
    tags: ["台北", "采耳", "耳朵清潔", "舒壓", "懶人包", "推薦"],
    author: {
      id: "author-3",
      name: "神秘客A",
      avatar: "https://readdy.ai/api/search-image?query=Asian%20woman%20with%20glasses%20portrait%20professional%20clean%20white%20background%20headshot&width=100&height=100&seq=203&orientation=squarish",
      bio: "資深美業神秘客，專精美容保養與外貌美化類評測，涵蓋美甲、美睫、霧眉、采耳、除毛與做臉等項目。擁有 5 年神秘客資歷，累積評測店家超過 120 間。善於從細節觀察服務品質，特別關注衛生標準與長期效果。堅持匿名探訪，幫助消費者找到最適合自己的美業選擇。",
    },
    publishedAt: "2025-03-28",
    readingTime: 7,
    rating: 4.8,
    reviewCount: 88,
    content: [
      {
        _type: "richText",
        _key: "intro",
        content: "<p>采耳（掏耳朵）聽起來很日常，但在專業師傅的操作下，那種酥麻感真的會讓人飄飄欲仙。台灣的采耳文化從四川傳統技法演進而來，發展出台式的細膩手法。</p><p>但采耳對衛生和技術要求極高，一旦操作不當可能造成耳朵不適甚至損傷。神秘客這次走訪了台北 12 間采耳店，從工具衛生、師傅技術、舒適度三個面向嚴格評比。</p>",
      },
      {
        _type: "featureList",
        _key: "criteria",
        title: "評比重點",
        features: [
          { _key: "c1", icon: "ri-shield-check-line", title: "衛生標準", description: "工具是否一客一消毒，師傅是否戴手套，環境整潔程度" },
          { _key: "c2", icon: "ri-tools-line", title: "師傅技術", description: "采耳深度控制、力道輕重、舒適感、溝通能力" },
          { _key: "c3", icon: "ri-hotel-bed-line", title: "環境體驗", description: "躺臥舒適度、環境安靜度、燈光控制" },
        ],
      },
      {
        _type: "cta",
        _key: "cta",
        title: "看更多采耳評比",
        subtitle: "神秘客實測台北采耳店，公正評比衛生標準與服務品質",
        buttonLabel: "查看采耳評比",
        buttonHref: "#",
      },
    ],
    seo: {
      title: "台北采耳推薦 TOP 5｜神秘客實測最舒適的采耳體驗",
      description: "台北采耳評比！神秘客走訪 12 間，精選 5 間手法細膩、衛生達標的采耳好去處。",
      keywords: ["台北采耳", "采耳推薦", "耳朵清潔", "采耳體驗"],
    },
  },
  {
    id: "post-5",
    slug: "taipei-facial-top8",
    title: "台北做臉推薦 TOP 8｜神秘客評比最有效的皮膚管理",
    excerpt: "做臉是長期肌膚投資，但選錯店家可能越做越糟。神秘客實測台北 25 間美容工作室，從技術、產品、服務三個維度嚴格篩選，精選出 8 間最值得信賴的做臉好店。",
    coverImage: "https://readdy.ai/api/search-image?query=Professional%20facial%20treatment%20in%20modern%20beauty%20clinic%20with%20skincare%20equipment%20clean%20white%20room%20therapist%20working%20on%20client%20soft%20lighting%20simple%20background%20photography&width=1200&height=630&seq=105&orientation=landscape",
    category: "做臉",
    contentType: "multiShopReview",
    tags: ["台北", "做臉", "皮膚管理", "清粉刺", "美容", "懶人包", "推薦"],
    author: {
      id: "author-1",
      name: "Amy編",
      avatar: "https://readdy.ai/api/search-image?query=Young%20asian%20woman%20portrait%20friendly%20smile%20clean%20white%20background%20lifestyle%20headshot&width=100&height=100&seq=201&orientation=squarish",
      bio: "資深美業神秘客，專精按摩與做臉/皮膚管理類評測。累積實地走訪超過 60 間按摩會館、SPA 與美容工作室，對於師傅手法、產品成分與療程效果有敏銳的判斷力。堅持匿名探訪，每次評比都親自體驗完整流程，確保資訊真實可靠。",
    },
    publishedAt: "2025-03-20",
    readingTime: 11,
    rating: 4.6,
    reviewCount: 112,
    content: [
      {
        _type: "richText",
        _key: "intro",
        content: "<p>「做臉」這個詞涵蓋範圍很廣——從最基礎的清潔做臉、清粉刺，到使用儀器的導入、超音波、甚至接近醫美等級的療程都算。選店前最重要的是先弄清楚自己的需求。</p><p>這次神秘客實測了台北 25 間美容工作室，從技術穩定性、產品成分透明度、無推銷壓力三個維度評比。這三個維度缺一不可，因為我們見過太多「技術很好但一直追加購」或「環境很美但效果掛零」的店家。</p>",
      },
      {
        _type: "shopReview",
        _key: "reviews",
        title: "TOP 8 做臉工作室評比",
        shops: [
          {
            _key: "s1",
            name: "美肌做臉中心",
            rating: 4.8,
            priceRange: "$1,500 - $5,000",
            address: "台北市大安區復興南路一段 280 號 3F",
            tags: ["皮膚檢測", "無推銷", "客製化療程"],
            pros: ["每次療程前用儀器分析皮膚狀態，針對當日膚況調整", "完全無推銷壓力，做完只給保養建議", "師傅技術穩定，每次效果一致"],
            cons: ["價格稍高，初次體驗費用較貴", "預約較難排到，需提前 1-2 週"],
            recommendation: "追求高品質皮膚管理的人首選。雖然貴，但真的是有效沒廢話的那種。",
            image: "https://readdy.ai/api/search-image?query=Modern%20beauty%20clinic%20with%20professional%20skin%20analysis%20equipment%20clean%20minimalist%20interior%20white%20room%20skincare%20therapy%20simple%20background%20photography&width=600&height=400&seq=315&orientation=landscape",
            storeUrl: "https://www.google.com/maps/search/?api=1&query=美肌做臉中心+台北+大安區",
          },
          {
            _key: "s2",
            name: "光采皮膚工作室",
            rating: 4.7,
            priceRange: "$1,200 - $3,500",
            address: "台北市中山區松江路 150 號 5F",
            tags: ["清粉刺", "導入療程", "中性偏油肌"],
            pros: ["清粉刺手法輕柔但效果明顯，不會過度刺激", "導入產品是日本進口醫美等級", "師傅會教你正確的居家保養方法"],
            cons: ["偏小的工作室空間，隱密性稍弱", "只接受預約，不接受臨時來訪"],
            recommendation: "毛孔問題嚴重或常清粉刺的人必看。手法輕柔是招牌，就算皮膚薄敏感也不怕。",
            image: "https://readdy.ai/api/search-image?query=Intimate%20skincare%20studio%20with%20soft%20lighting%20facial%20treatment%20chair%20and%20professional%20beauty%20products%20clean%20simple%20background%20photography&width=600&height=400&seq=316&orientation=landscape",
            storeUrl: "https://www.google.com/maps/search/?api=1&query=光采皮膚工作室+台北+中山區",
          },
        ],
      },
      {
        _type: "faq",
        _key: "faq",
        title: "做臉常見問題",
        items: [
          { _key: "q1", question: "做臉多久要做一次？", answer: "一般保養建議每月 1-2 次。清粉刺可以每 2-4 週一次，配合肌膚代謝週期。" },
          { _key: "q2", question: "做完臉可以馬上出門嗎？", answer: "清潔做臉後皮膚可能輕微泛紅，建議不要馬上曬太陽。若有清粉刺，建議當天不要化妝。" },
        ],
      },
      {
        _type: "cta",
        _key: "cta",
        title: "看更多做臉評比",
        subtitle: "神秘客實測台北美容工作室，公正評比技術與產品品質",
        buttonLabel: "查看做臉評比",
        buttonHref: "#",
      },
    ],
    seo: {
      title: "台北做臉推薦 TOP 8｜神秘客實測皮膚管理評比 2025",
      description: "台北做臉評比！神秘客實測 25 間美容工作室，精選 8 間最有效、無推銷壓力的皮膚管理好店。",
      keywords: ["台北做臉", "做臉推薦", "皮膚管理", "清粉刺", "美容工作室"],
    },
  },
];